module.exports = __webpack_public_path__ + "img/id-card4.dd2b1ef5.png";